import * as Yup from 'yup';
import type { IStartChargeFormField } from 'models/start-charge';
import { Common } from 'utils/constants';

export const StartChargeSchema = (t) => {
    return Yup.object().shape({
        email: Yup.string()
            .matches(Common.RegularExpression.EmailRegularExpression, t('startCharge.errors.inValidEmail'))
            .required('required'),
        tnc: Yup.boolean().oneOf([true], t('startCharge.errors.acceptTnc')).required('required'),
    }) as Yup.SchemaOf<IStartChargeFormField>;
};
